import { stripTrailingSlash } from './normalizePathname';

/**
 * Adds location origin to a path to create a full URL
 *
 * @example
 *  addLocationOriginToUrl('/some/url/', 'https://www.zapier.ninja/')
 *  > 'https://www.zapier.ninja/some/url/'
 */
const addLocationOriginToUrl = (url: string, origin?: string) => {
  // defaulting the argument would break imports on server-side
  if (typeof origin === 'undefined' && typeof window !== 'undefined') {
    origin = window.location.origin;
  }
  const httpProtocolMatch = url.match(/https?:\/\//);
  if (httpProtocolMatch && httpProtocolMatch.index === 0) {
    return url;
  }

  return `${stripTrailingSlash(origin)}${url}`;
};

export default addLocationOriginToUrl;
